module.exports = __webpack_public_path__ + "img/blm3.8414010d.png";